import { atom as e } from "jotai";
const o = e([]), a = e((s) => s(o)), c = e(
  null,
  (s, m, i) => {
    i ? m(o, (t) => [
      {
        ...i,
        id: (/* @__PURE__ */ new Date()).getTime()
      },
      ...t
    ]) : m(o, (t) => t.slice(0, -1));
  }
);
export {
  a as getToastsAtom,
  c as setToastAtom,
  o as toastsAtom
};
